import { tokenService } from './tokenService';
import { asyncStorage } from '../storage/asyncStorageService';

// Read tokens directly from storage — no refresh, no expiry checks.
// Token refresh is handled exclusively by the axios error interceptor in cachedAxiosConfig.js
// when the server returns 401/403. Doing it here too causes race conditions and loops.
export const getAuthHeaders = () => {
  const accessToken = asyncStorage.get('accessToken') || sessionStorage.getItem('accessToken');
  const idToken = asyncStorage.get('idToken') || sessionStorage.getItem('idToken');
  const email = tokenService.getEmail();

  return {
    'Authorization': accessToken ? `Bearer ${accessToken}` : '',
    'X-Auth-Token': idToken ? `Bearer ${idToken}` : ''
  };
};

export const getAuthHeadersSync = getAuthHeaders;
